/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import React from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { WebChatIcon } from './WebChatIcon';

/**
 * A component to render a SMS Custom provider Icon.
 */

export const CustomSMSIcon = () => {
  const { formatMessage: t } = useIntl();

  return (
    <div className="CustomSMS__icon">
      <WebChatIcon fill="#0f62fe" />
      {t(messages.customSMS)}
    </div>
  );
};
